import { render } from "./ProfileImagesAdminView.vue?vue&type=template&id=3bc3baa4&scoped=true"
import script from "./ProfileImagesAdminView.vue?vue&type=script&lang=js"
export * from "./ProfileImagesAdminView.vue?vue&type=script&lang=js"

import "./ProfileImagesAdminView.vue?vue&type=style&index=0&id=3bc3baa4&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc3baa4"]])

export default __exports__